import { RepositoryFactory } from "../../api/RepositoryFactory";
import ApiErrorHandler from "@/_helpers/apiErrorHandler.js";

const DeviceRepository = RepositoryFactory.get("devicefields");

export const deviceFields = {
  namespaced: true,
  state: {
    fields: [],
    templates: [],
    field: {},
    status: {
      loading: false,
    },
  },

  actions: {
    async get({ dispatch, commit, rootState }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;
      var companyId = rootState.users.userCompany.companyId;

      await DeviceRepository.get(user, companyId)
        .then((fields) => {
          commit("SET_FIELDS", fields.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getById({ dispatch, commit, rootState }, deviceFieldId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.getById(user, deviceFieldId)
        .then((fields) => {
          commit("SET_FIELD", fields.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getFieldsForDevice({ dispatch, commit, rootState }, deviceId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await RepositoryFactory.get("devices")
        .getFieldsForDevice(user, deviceId)
        .then((fields) => {
          commit("SET_FIELDS", fields.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );
    },

    async create({ dispatch, commit, rootState }, { deviceId, payload }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.create(user, deviceId, payload)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async update({ dispatch, commit, rootState }, { deviceFieldId, payload }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.update(user, deviceFieldId, payload)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async delete({ dispatch, commit, rootState }, deviceFieldId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.delete(user, deviceFieldId)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getTemplates({ dispatch, commit, rootState }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.getTemplates(user)
        .then((templates) => {
          commit("SET_TEMPLATES", templates.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async createTemplate({ dispatch, commit, rootState }, payload) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.createTemplate(user, payload)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async updateTemplate(
      { dispatch, commit, rootState },
      { deviceFieldTemplateId, payload }
    ) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.updateTemplate(
        user,
        deviceFieldTemplateId,
        payload
      )
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async deleteTemplate(
      { dispatch, commit, rootState },
      deviceFieldTemplateId
    ) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.delete(user, deviceFieldTemplateId)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },
  },

  mutations: {
    LOADING(state, status) {
      state.status.loading = status;
    },

    SET_FIELDS(state, fields) {
      state.fields = fields;
    },

    SET_FIELD(state, field) {
      state.field = field;
    },

    SET_TEMPLATES(state, templates) {
      state.templates = templates;
    },
  },
};
